import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AboutComponent {
  experiences = [
    {
      designation: 'Software Development Engineer',
      companyName: 'Tech Alchemy Studios, Pune',
      startDate: 'Aug, 2023',
      endDate: 'Present',
      desc: 'Driving frontend development across high-impact Web3 and gaming platforms. Built dynamic features like crypto-enabled games, NFT marketplaces, and trading dashboards using Angular, PixiJS, and TradingView, with a strong focus on performance, scalability, and user experience.',
      icon: 'assets/images/svg/briefcase.svg'
    },
    {
      designation: 'Software Engineer',
      companyName: 'Coditas Solutions LLP, Pune',
      startDate: 'Feb, 2021',
      endDate: 'July, 2023',
      desc: 'Engineered responsive, cross-platform web applications with a focus on real-time collaboration and data visualization. Integrated Highcharts, implemented NgRx for state management, and built scalable REST APIs with Express.js — delivering seamless user experiences across devices.',
      icon: 'assets/images/svg/briefcase.svg'
    }
  ]
 }
